// Fires a `pageview` analytics event whenever the route changes.
// Mounted once at the top of <App>.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track, attachAnalytics } from '../lib/analytics';

export default function RouteTracker() {
  const loc = useLocation();
  useEffect(() => {
    attachAnalytics();
  }, []);
  useEffect(() => {
    track('pageview', { path: loc.pathname + loc.search });
  }, [loc.pathname, loc.search]);
  return null;
}
